import React from 'react';
import Layout from '../components/Layout';
import { Switch, Route } from 'react-router-dom';
import Exchange from '../pages/exchange';
import Markets from '../pages/markets';
import Profile from './profile';
import Wallet from './wallet';
import Settings from './settings';
import Login from './login';
import Reset from './reset';
import OtpVerify from './otp-verify';
import OtpNumber from './otp-number';
import Lock from './lock';
import TermsAndConditions from './terms-and-conditions';
import NewsDetails from './news-details';
import Signup from './signup';
import Notfound from './notfound';
import Home1 from '../components/Home';
import AdminPanel from './admin';
import Arbitrage from './Arbitrage';

export default function index() {
  return (
    <div style={{overflowX: "hidden"}}>
      <Layout>
        <Switch>
          <Route exact path="/exchange">
            <Exchange />
          </Route>
          <Route exact path="/">
            <Home1 />
          </Route>
          <Route path="/markets">
            <Markets />
          </Route>
          <Route path="/profile">
            <Profile />
          </Route>
          <Route path="/arbitrage">
            <Arbitrage />
          </Route>
          <Route path="/wallet">
            <Wallet />
          </Route>
          <Route path="/settings">
            <Settings />
          </Route>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/signup">
            <Signup />
          </Route>
          <Route path="/reset">
            <Reset />
          </Route>
          <Route path="/otp-verify">
            <OtpVerify />
          </Route>
          <Route path="/otp-number">
            <OtpNumber />
          </Route>
          <Route path="/lock">
            <Lock />
          </Route>
          <Route path="/terms-and-conditions">
            <TermsAndConditions />
          </Route>
          <Route path="/news-details">
            <NewsDetails />
          </Route>
          <Route path="/notfound">
            <Notfound />
          </Route>
          <Route path="/dashboard-mkt">
            <AdminPanel />
          </Route>
        </Switch>
      </Layout>
    </div>
  );
}
